export class BaseUserDto {
    UserId: string;
    Token: string;
    TokenTypeId: number;
    RegistrationTypeId: number;
    ActivationCode: string;
}